import React, { useEffect } from 'react';

type AppErrorFallbackProps = {
    onNavigate: () => void;
};

const AppErrorFallback = ({ onNavigate }: AppErrorFallbackProps) => {
    useEffect(() => {
        window.addEventListener('popstate', onNavigate);
        return () => window.removeEventListener('popstate', onNavigate);
    }, [onNavigate]);

    return (
        <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
            <h2>Something went wrong</h2>
            <p>An unexpected error occurred. Please refresh the page.</p>
            <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                    padding: '8px 16px',
                    background: '#1c2a38',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer',
                }}
            >
                Refresh
            </button>
        </div>
    );
};

export default AppErrorFallback;
